<template>
  <div
    v-if="showSocial || showIncidents"
    :class="{
      'hyp-source-container-2': !showIncidents,
      'hyp-source-container-3': showIncidents,
    }"
  >
    <div
      class="pull-left text-center hyp-source-btn hyp-source-btn-left"
      :class="{
        'hyp-source-btn-selected': selectedType === 'news',
        'hyp-source-btn-2': !showIncidents || !showSocial,
        'hyp-source-btn-3': showIncidents && showSocial,
        disabled: hasEssentialsAccess,
      }"
      @click="toggle('news')"
    >
      News
    </div>
    <div
      v-if="showSocial"
      class="pull-left text-center hyp-source-btn"
      :class="{
        'hyp-source-btn-selected': selectedType === 'social',
        'hyp-source-btn-2 hyp-source-btn-right': !showIncidents || !showSocial,
        'hyp-source-btn-3 hyp-source-btn-middle': showIncidents && showSocial,
        disabled: hasEssentialsAccess,
      }"
      @click="toggle('social')"
    >
      Social
    </div>
    <div
      v-if="showIncidents"
      class="pull-left text-center hyp-source-btn hyp-source-btn-right"
      :class="{
        'hyp-source-btn-selected': selectedType === 'incidents',
        'hyp-source-btn-2': !showIncidents || !showSocial,
        'hyp-source-btn-3': showIncidents && showSocial,
      }"
      @click="toggle('incidents')"
    >
      Verified
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import {
  hasTwitterAccess,
  hasEssentialsAccess,
} from "@/services/user/user.service";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "DetailsSourceSelector",
  props: {
    selected: {
      type: String,
      validator: function (value) {
        return ["news", "social", "incidents"].indexOf(value) !== -1;
      },
      default: "news",
    },
    isMonitor: {
      type: Boolean,
      default: false,
    },
    includeIncidents: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      selectedType: hasEssentialsAccess() ? "incidents" : this.selected,
      hasEssentialsAccess: hasEssentialsAccess(),
    };
  },
  computed: {
    showSocial() {
      return !this.hasEssentialsAccess && hasTwitterAccess();
    },
    showIncidents() {
      return this.includeIncidents;
    },
  },
  methods: {
    toggle(type) {
      if (this.hasEssentialsAccess && type !== "incidents") {
        return;
      }

      this.selectedType = type;
      this.$emit(EMITTED_ACTIONS.CLICK, type);
      this.handlePageTrackerEvent(
        EVENT_CATEGORIES.event_details_source,
        EVENT_ACTIONS.clicked,
        type
      );
    },
  },
  watch: {
    selected: {
      handler(newValue) {
        if (this.hasEssentialsAccess && newValue !== "incidents") {
          return;
        } else {
          this.selectedType = newValue;
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.hyp-source-container-2 {
  width: 100px;
  font-size: 12px;
}
.hyp-source-container-3 {
  width: 200px;
  font-size: 12px;
}
.hyp-source-btn {
  color: white;
  border: 1px solid #7f7f7f;
  padding: 2px 0;
  cursor: pointer;
}
.hyp-source-btn-2 {
  width: 50%;
}
.hyp-source-btn-3 {
  width: 33%;
}
.hyp-source-btn-left {
  border-right: none;
  border-radius: 4px 0 0 4px;
}
.hyp-source-btn-middle {
  border-right: none;
}
.hyp-source-btn-right {
  border-radius: 0 4px 4px 0;
}
.hyp-source-btn-selected {
  background-color: $primary-color;
}
[class*="hyp-source-btn"].disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
